
export const setShowBackView = {
  methods: {
    setShowBackView (isShow, url) {
      if (this.$terminal === 'Android') {
        if (window.jdJsCallNative) {
          window.jdJsCallNative.callNativeShowBackView(isShow, url)
        }
      } else if (this.$terminal === 'IOS') {
        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.callNativeShowBackView.postMessage({ isShow, url })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setShowBackView.js